import { RemoteAddPlaceToGroup } from 'data/usecases';
import { AddPlaceToGroupUseCaseInterface } from 'domain/usecases';
import { makeApiUrlAddPlaceToGroup } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteAddPlaceToGroup = (): AddPlaceToGroupUseCaseInterface =>
  new RemoteAddPlaceToGroup(makeApiUrlAddPlaceToGroup(), makeAxiosHttpClient());
